import React from 'react';
import PropTypes from 'prop-types';
import { userProps } from 'app/utils/propValidation';
import { numbers } from 'app/utils';
import { NumericalValue, Text } from 'modules/styled';

export default function Percent(props) {
  if (!props?.user?.relevance) return null;

  const { size, sx, ...rest } = props;
  const percent = Math.max(0, numbers.percentChange(props?.user?.relevance));
  const percentPretty = numbers.abbreviateNumber(percent);
  const isNegative = percent < 0;
  return (
    <NumericalValue {...rest} sx={{ ...sx }}>
      <Text
        sx={{
          fontSize: size,
          color: isNegative ? 'red' : 'green',
        }}
      >
        {isNegative ? '▼ ' : '▲ '}
      </Text>
      {percentPretty}%
    </NumericalValue>
  );
}

Percent.propTypes = {
  user: userProps,
  sx: PropTypes.object,
  size: PropTypes.number,
};
